import reducer, { InferenceResultState } from "./reducers";
import * as inferenceResultOperations from "./operations";
export {
  inferenceResultOperations,
  InferenceResultState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/inference/index.ts